import { axios } from "../../shared/axios";
import { getDataFromStore } from "../../store/getStore"
const errorMessage = "Something went wrong. Please try again";


export const getToken = () => {
    // console.log(section, "amrit")   
    let auth = getDataFromStore("Auth");
    // console.log(auth.authDetails.token)
    if (auth.authDetails.token) {
        return auth.authDetails.token
    }
    else {
        return null;
    }
};

export const apiFunction = async (url, method, postData, token, extraConfig) => {
    // console.log("sadsadas")
    let config = {
        method: method,
        url: url,
        data: postData ? postData : {},
        headers: { institutionId: process.env.REACT_APP_INSTITUTION_ID }
    };
    // console.log(config, token);
    let data;
    if (token) {
        let token = getToken();
        //console.log(token)
        config = {
            ...config,
            headers: {
                'x-access-token': `${token}`,
                institutionId: process.env.REACT_APP_INSTITUTION_ID
            }
        };
    }

    if (extraConfig == "blob") {
        config = {
            ...config,
            responseType: 'blob',
        }
    }

    if (extraConfig == "multipart") {
        config.headers = {
            ...config.headers,
            "content-type": "multipart/form-data",
        }
    }


    await axios({ ...config })
        .then((res) => {
            // console.log(res);
            if (extraConfig == "blob") {
                data = res.data
            }
            else {
                if (res.data) {
                    data = {
                        data: res.data,
                        status: true,
                        message: "Success",
                    };
                } else {
                    data = {
                        status: true,
                        message: "Success",
                    };
                }
            }
        })
        .catch((err) => {
            console.log(err);

            // `err.response` only exists when the server actually answered.
            // For a dropped connection, timeout, CORS rejection or offline
            // client it is undefined, and reading `.data` off it threw a
            // TypeError *inside the catch* — which escaped as an uncaught
            // runtime error and took the whole page down instead of letting
            // the caller handle a failed request.
            if (err?.response?.data) {
                data = { ...err.response.data, status: false };
            } else {
                data = {
                    status: false,
                    code: 0,
                    message:
                        err?.message === "Network Error"
                            ? "Could not reach the server. Check your connection and try again."
                            : err?.message || errorMessage,
                };
            }
        });
    // console.log(data);
    return data;
};

export const postFormDataAPI = async (url, postData, section) => {
    let token = getToken(section);
    let data;
    const config = {
        headers: {
            "content-type": "multipart/form-data",
            token: `${token}`,
            institutionId: process.env.REACT_APP_INSTITUTION_ID
        },
    };
    await axios
        .post(url, postData, config)
        .then((res) => {
            data = res.data;
        })

        .catch((err) => {
            console.log(err);

            // Same guard as apiFunction: no response object on a network
            // failure, so reading `.data` off it would throw.
            if (err?.response?.data) {
                data = { ...err.response.data, status: false };
            } else {
                data = {
                    status: false,
                    code: 0,
                    message:
                        err?.message === "Network Error"
                            ? "Could not reach the server. Check your connection and try again."
                            : err?.message || errorMessage,
                };
            }
        });
    return data;
};
